<div class="ui basic segment max-width" [class.loading]="isLoading">
    <app-header title="{{ 'time-off-v3.editApprovalFlow' | translate }}" [back]="true"></app-header>
    <!--    Overall Settings-->
    <div class="ui segment">
        <app-segment-header title="{{ 'time-off-v3.overallSettings' | translate }}"></app-segment-header>
        <app-approval-flow-overall-settings-form
            #approvalFlowOverallSettingsForm
            [timeOffApprovalFlow]="timeOffApprovalFlow"
        ></app-approval-flow-overall-settings-form>
    </div>

    <!--    Approval Steps-->
    <div class="ui segment" [class.loading]="approvalFlowStepsForm.isLoading" *ngIf="!timeOffApprovalFlow.isAutomatic">
        <app-segment-header title="{{ 'time-off-v3.approvalSteps' | translate }}"></app-segment-header>
        <app-approval-flow-steps-form
            [approvalFlow]="timeOffApprovalFlow"
            #approvalFlowStepsForm
        ></app-approval-flow-steps-form>
    </div>

    <!--    Approval Observers-->
    <div class="ui segment" [class.loading]="approvalObserversForm.isLoading">
        <app-segment-header title="{{ 'time-off-v3.notificationsUponApproval' | translate }}"></app-segment-header>
        <app-approval-observers-form
            [approvalFlow]="timeOffApprovalFlow"
            #approvalObserversForm
        ></app-approval-observers-form>
    </div>

    <!--    Buttons-->
    <div class="buttons">
        <ui-button type="outline" (click)="onCancel()">{{ 'time-off-v3.cancel' | translate }}</ui-button>
        <ui-button
            [disabled]="approvalFlowStepsForm?.approvalFlowSteps?.length === 0"
            type="primary"
            (click)="onSave()"
            >{{ 'time-off-v3.save' | translate }}</ui-button
        >
    </div>
</div>
